import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Login actions (for legacy support)
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.user = null;
      state.error = action.payload.error || 'Login failed';
    },
    
    // Register actions
    registerStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    registerSuccess: (state) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.error = null;
    },
    registerFailure: (state, action) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.error = action.payload.error || 'Registration failed';
    },
    
    // Logout action
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.loading = false;
      state.error = null;
    },
    
    // Refresh token action
    refreshToken: (state, action) => {
      state.user = action.payload.user;
    },
    
    // Clear error action
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Handle async thunk actions
    builder
      // Login thunk
      .addCase('auth/login/pending', (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase('auth/login/fulfilled', (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
        state.user = action.payload;
        state.error = null;
      })
      .addCase('auth/login/rejected', (state, action) => {
        state.loading = false;
        state.isLoggedIn = false;
        state.user = null;
        state.error = action.payload || 'Login failed';
      })
      // Register thunk
      .addCase('auth/registerUser/pending', (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase('auth/registerUser/fulfilled', (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
        state.user = action.payload;
        state.error = null;
      })
      .addCase('auth/registerUser/rejected', (state, action) => {
        state.loading = false;
        state.isLoggedIn = false;
        state.user = null;
        state.error = action.payload || 'Registration failed';
      })
      // Refresh token thunk
      .addCase('auth/refreshToken/fulfilled', (state, action) => {
        state.user = action.payload;
      });
  },
});

// Export actions
export const {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  logout,
  refreshToken,
  clearError,
} = authSlice.actions;

// Export selectors
export const selectAuth = (state) => state.auth;
export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const selectUser = (state) => state.auth.user;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;

// Export reducer
export default authSlice.reducer;